/** @typedef	{import('./CopyEmbedCodeProps').SharedProps} Props */

import { translate } from '../../Internationalization';
import BaseForm from '../../../shared/Forms/BaseForm';
import FieldRadioGroup from '../../../shared/Forms/Fields/FieldRadioGroup';
import React from 'react';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function LanguageOptions(props) {
	return (
		<BaseForm
			initialValues={{ codeType: props.codeType }}
			noRequiredText={true}
			onSubmit={props.onTypeUpdate}
		>
			<fieldset>
				<FieldRadioGroup
					disabled={props.isGettingData || false}
					name="codeType"
					onClick={props.onTypeUpdate}
					required={true}
					values={[
						[
							'javascript',
							translate(
								'agent.pages.widgets.lead_generation.embed.recommended'
							),
						],
						[
							'iframe',
							translate(
								'agent.pages.widgets.lead_generation.embed.iframe'
							),
						],
					]}
				/>
			</fieldset>
		</BaseForm>
	);
}

export default React.memo(LanguageOptions);
